<template>
  <header role="banner" class="hero">
    <div class="hero-head">
      <hero-section-navbar/>
    </div>
    <div class="hero-body">
      <div class="container">
        <h1>Invoices made easy</h1>
        <h2>Fill out the form below and generate your free PDF invoice</h2>
      </div>
    </div>
  </header>
</template>

<script>
import HeroSectionNavbar from './HeroSectionNavbar'

export default {
  name: 'HeroSection',
  components: {
    HeroSectionNavbar
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/Variables.scss';

.hero {
  align-items: stretch;
  background: $grandaddy-purp;
  color: $white-widow;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .hero-head {
    flex-grow: 0;
    flex-shrink: 0;
  }
  .hero-body {
    flex-grow: 1;
    flex-shrink: 0;
    padding: 3rem 1.5rem;
    .container {
      text-align: center;
    }
  }
}

@media (min-width: 768px) {
  .hero {
    .hero-body {
      padding-bottom: 9rem;
      padding-top: 9rem;
    }
  }
}
</style>
